"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDotsStyles = exports.getCarouselStyles = void 0;
var react_1 = require("@emotion/react");
var getCarouselStyles = function (theme, carouselTheme) {
    if (carouselTheme === void 0) { carouselTheme = 'light'; }
    var themedControlStyles = {
        dark: {
            color: theme.color.WHITE.DEFAULT,
            background: 'rgba(0, 0, 0, 0.9)',
            '&:disabled': {
                transform: ' translateY(-50%) scale(0)',
            },
        },
        light: {
            color: theme.color.GRAY.DARK_2,
            background: 'rgba(255, 255, 255, 0.9)',
            '&:disabled': {
                transform: ' translateY(-50%) scale(0)',
            },
        },
    };
    return {
        container: react_1.css({
            width: '100%',
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '8px',
            '& > img': {
                width: '100%',
                height: '100%',
                objectFit: 'cover',
            },
        }),
        controls: react_1.css(__assign({ zIndex: 1, top: '50%', transition: 'all .2s linear', transform: ' translateY(-50%) scale(1)', cursor: 'pointer', outline: 'none', position: 'absolute', border: 'none', width: 36, height: 36, display: 'grid', placeItems: 'center', backdropFilter: 'blur(4px)', borderRadius: '18px' }, themedControlStyles[carouselTheme])),
    };
};
exports.getCarouselStyles = getCarouselStyles;
var getDotsStyles = function (theme, dotsTheme) {
    var themedContainerStyles = {
        light: {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
        },
        dark: {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
        },
    };
    var themedDotStyles = {
        light: {
            backgroundColor: theme.color.GRAY.DARK_4,
        },
        dark: {
            backgroundColor: theme.color.GRAY.DEFAULT,
        },
    };
    return {
        container: react_1.css(__assign({ backdropFilter: 'blur(4px)', height: 24, width: 'fit-content', borderRadius: 12, padding: 8 }, themedContainerStyles[dotsTheme])),
        dot: react_1.css(__assign({ transition: 'background-color .2s linear', padding: 0, cursor: 'pointer', outline: 'none', border: 'none', width: 8, height: 8, borderRadius: '100%' }, themedDotStyles[dotsTheme])),
    };
};
exports.getDotsStyles = getDotsStyles;
